var map = {
	"./template.bet575": 1750,
	"./template.bet575.tsx": 1750,
	"./template.bet777": 1751,
	"./template.bet777.tsx": 1751,
	"./template.betprofessor": 1752,
	"./template.betprofessor.tsx": 1752,
	"./template.betroyale": 1753,
	"./template.betroyale.tsx": 1753,
	"./template.betstride": 1754,
	"./template.betstride.tsx": 1754,
	"./template.buffalobet": 1755,
	"./template.buffalobet.tsx": 1755,
	"./template.chromabet": 1756,
	"./template.chromabet.tsx": 1756,
	"./template.default": 717,
	"./template.default.tsx": 717,
	"./template.epicodds": 1757,
	"./template.epicodds.tsx": 1757,
	"./template.fiestabet": 1758,
	"./template.fiestabet.tsx": 1758,
	"./template.forsport": 1759,
	"./template.forsport.tsx": 1759,
	"./template.gigabet": 1760,
	"./template.gigabet.tsx": 1760,
	"./template.goldenbet888": 1761,
	"./template.goldenbet888.tsx": 1761,
	"./template.goldenrush": 1762,
	"./template.goldenrush.tsx": 1762,
	"./template.hyperbet": 1763,
	"./template.hyperbet.tsx": 1763,
	"./template.juicybet": 1764,
	"./template.juicybet.tsx": 1764,
	"./template.junglebet": 1765,
	"./template.junglebet.tsx": 1765,
	"./template.magnumbet": 1766,
	"./template.magnumbet.tsx": 1766,
	"./template.oldgill": 1767,
	"./template.oldgill.tsx": 1767,
	"./template.puntcity": 1768,
	"./template.puntcity.tsx": 1768,
	"./template.puntgenie": 1769,
	"./template.puntgenie.tsx": 1769,
	"./template.pyramidbet": 1770,
	"./template.pyramidbet.tsx": 1770,
	"./template.questbet": 1771,
	"./template.questbet.tsx": 1771,
	"./template.slambet": 1772,
	"./template.slambet.tsx": 1772,
	"./template.sterlingparker": 1773,
	"./template.sterlingparker.tsx": 1773,
	"./template.templebet": 1774,
	"./template.templebet.tsx": 1774,
	"./template.titanbet": 1775,
	"./template.titanbet.tsx": 1775,
	"./template.ts": 993,
	"./template.vikingbet": 1776,
	"./template.vikingbet.tsx": 1776,
	"./template.volcanobet": 1777,
	"./template.volcanobet.tsx": 1777,
	"./template.wellbet": 1778,
	"./template.wellbet.tsx": 1778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2480;